import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";

import { getTranslations } from "../api/translations";
import { applyTranslations } from "../i18n/bootstrap";

/** Long-lived query that keeps i18next in sync with admin edits.
 *
 * Mounted once near the root of the app. Refetches on the global staleTime
 * (30s). On each successful refetch the result is reapplied via
 * addResourceBundle, so live edits in the Django admin propagate within
 * ~30 seconds without a page reload.
 */
export function useTranslationsQuery() {
  const q = useQuery({
    queryKey: ["translations"] as const,
    queryFn: getTranslations,
    // Critical: we already booted with this data; do not show a loading state
    // on refetches and do not block paint on background refetches.
    notifyOnChangeProps: ["data"],
  });
  useEffect(() => {
    if (q.data) applyTranslations(q.data);
  }, [q.data]);
  return q;
}
